import { DOCKER_STATUS_CHECK_TASKSCRIBE } from '../../common/actionTypes';
const INITIAL_STATE = {
  taskscribedockerStatus: false,
};

const taskscribeReducer = (state = INITIAL_STATE, action) => {
  if (action.type === undefined) {
    return state;
  }
  switch (action.type) {
    case DOCKER_STATUS_CHECK_TASKSCRIBE: {
      return { ...state, taskscribedockerStatus: action.payload };
    }
    default:
      return state;
  }
};

export default taskscribeReducer;
